import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, createVNode as _createVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "employee-details-expanded" }
const _hoisted_2 = { class: "details-container" }
const _hoisted_3 = { class: "date-controls log-filters-compact mb-3" }
const _hoisted_4 = { class: "row g-1 align-items-end" }
const _hoisted_5 = { class: "col-md-5" }
const _hoisted_6 = { class: "col-md-5" }
const _hoisted_7 = { class: "col-md-2" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "invalid-feedback d-block mt-1"
}
const _hoisted_10 = {
  key: 0,
  class: "details-skeleton"
}
const _hoisted_11 = { class: "card mb-3" }
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "row g-3" }
const _hoisted_14 = { class: "alert alert-danger" }
const _hoisted_15 = { class: "mb-0 mt-1" }
const _hoisted_16 = { class: "data-content" }
const _hoisted_17 = { class: "card mb-4" }
const _hoisted_18 = { class: "card-header d-flex justify-content-between align-items-center" }
const _hoisted_19 = { class: "badge bg-primary" }
const _hoisted_20 = { class: "card-body" }
const _hoisted_21 = {
  key: 0,
  class: "stats-grid"
}
const _hoisted_22 = { class: "stat-card" }
const _hoisted_23 = { class: "stat-value" }
const _hoisted_24 = { class: "stat-card" }
const _hoisted_25 = { class: "stat-value" }
const _hoisted_26 = { class: "stat-card" }
const _hoisted_27 = { class: "stat-value" }
const _hoisted_28 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_29 = {
  key: 0,
  class: "card mb-4"
}
const _hoisted_30 = { class: "card-body" }
const _hoisted_31 = {
  key: 0,
  class: "chart-placeholder"
}
const _hoisted_32 = {
  key: 1,
  class: "chart-error"
}
const _hoisted_33 = { class: "card" }
const _hoisted_34 = { class: "card-body p-0" }
const _hoisted_35 = {
  key: 0,
  class: "bookings-list"
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "d-flex justify-content-between" }
const _hoisted_38 = { class: "fw-bold" }
const _hoisted_39 = { class: "small text-muted" }
const _hoisted_40 = { class: "text-end" }
const _hoisted_41 = { class: "badge bg-secondary" }
const _hoisted_42 = { class: "small text-muted mt-1" }
const _hoisted_43 = {
  key: 1,
  class: "p-3 text-muted"
}

import { ref, computed } from 'vue';
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent
} from "echarts/components";
import VChart from "vue-echarts";
import { useQuery } from '@tanstack/vue-query';
import { fetchUserBookings } from '../../../../api/queries/accountQueries.js';
import { useMasterDataQuery } from '../../../../api';
import { queryKeys } from '../../../../api/queryKeys.js';
import { useBookingActions } from '../../../../composables/useBookingActions.js';
import UserBookingMetrics from '../components/UserBookingMetrics.vue';
import { differenceInCalendarDays, format, isValid, parseISO } from 'date-fns';
import { tz } from '@date-fns/tz';


export default {
  __name: 'EmployeeDetailsExpanded',
  props: {
  employee: {
    type: Object,
    required: true
  },
  defaultFromDate: {
    type: Date,
    required: true
  },
  defaultUntilDate: {
    type: Date,
    required: true
  }
},
  setup(__props) {

const berlinTz = tz('Europe/Berlin');

// Register ECharts components (tree-shaking)
use([
  CanvasRenderer,
  BarChart,
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent
]);

// Props
const props = __props;

// Date range controls
const fromDateInput = ref(format(props.defaultFromDate, 'yyyy-MM-dd', { in: berlinTz }));
const untilDateInput = ref(format(props.defaultUntilDate, 'yyyy-MM-dd', { in: berlinTz }));
const appliedFromDate = ref(fromDateInput.value);
const appliedUntilDate = ref(untilDateInput.value);
const dateError = ref('');

// Chart loading and error states
const isLoadingBookingsPerDay = ref(false);
const errorBookingsPerDay = ref(null);

// Create computed query key for bookings that reacts to date changes
const bookingsQueryKey = computed(() => queryKeys.accountUserBookings({
  employeeId: props.employee.id,
  from: appliedFromDate.value,
  until: appliedUntilDate.value
}));

// Validate date range
const validateDateRange = () => {
  const from = fromDateInput.value ? parseISO(fromDateInput.value) : new Date(NaN);
  const until = untilDateInput.value ? parseISO(untilDateInput.value) : new Date(NaN);
  
  if (!isValid(from) || !isValid(until)) {
    dateError.value = 'Bitte geben Sie gültige Datumsangaben ein.';
    return false;
  }
  
  if (until < from) {
    dateError.value = 'Das Enddatum muss nach dem Startdatum liegen.';
    return false;
  }
  
  dateError.value = '';
  return true;
};

// Fetch bookings data
const {
  data: bookings,
  isFetching: isFetchingBookings,
  error: bookingsError,
  refetch: refetchBookings
} = useQuery({
  queryKey: bookingsQueryKey,
  queryFn: () => {
    if (!validateDateRange()) {
      return Promise.reject(new Error('Ungültiger Datumsbereich'));
    }
    
    return fetchUserBookings({
      employeeId: props.employee.id,
      from: appliedFromDate.value,
      until: appliedUntilDate.value
    });
  },
  enabled: true,
  staleTime: 5 * 60 * 1000, // 5 minutes
});

const { data: masterData } = useQuery(useMasterDataQuery());
const isLoadingData = computed(() => isFetchingBookings.value);
const bookingActions = useBookingActions();

// Computed statistics
const futureBookingsCount = computed(() => {
  if (!bookings.value) return 0;
  const now = new Date();
  return bookings.value.filter(booking => new Date(booking.startTime) > now).length;
});

const pastBookingsCount = computed(() => {
  if (!bookings.value) return 0;
  const now = new Date();
  return bookings.value.filter(booking => new Date(booking.startTime) <= now).length;
});

// Utilization proxy: percentage of days with at least one booking in the period
// This is a simple proxy for how much the employee uses the booking system
const utilizationPercentage = computed(() => {
  if (!bookings.value || bookings.value.length === 0) return 0;
  
  const from = parseISO(appliedFromDate.value);
  const until = parseISO(appliedUntilDate.value);
  const totalDays = differenceInCalendarDays(until, from) + 1;
  
  // Count unique days with bookings
  const bookingDays = new Set();
  bookings.value.forEach(booking => {
    const bookingDate = new Date(booking.startTime);
    const dateKey = format(bookingDate, 'yyyy-MM-dd', { in: berlinTz });
    if (dateKey >= appliedFromDate.value && dateKey <= appliedUntilDate.value) {
      bookingDays.add(dateKey);
    }
  });
  
  // Calculate percentage
  return totalDays > 0 ? Math.round((bookingDays.size / totalDays) * 100) : 0;
});

// Refresh all data
const refreshData = () => {
  if (validateDateRange()) {
    const hasDateChanged = appliedFromDate.value !== fromDateInput.value
      || appliedUntilDate.value !== untilDateInput.value;

    appliedFromDate.value = fromDateInput.value;
    appliedUntilDate.value = untilDateInput.value;

    if (!hasDateChanged) {
      refetchBookings();
    }
  }
};

// Format date for display
const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return isValid(date) ? format(date, 'dd.MM.yyyy') : 'Invalid Date';
};

// Format time for display
const formatTime = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return isValid(date) ? format(date, 'HH:mm') : 'Invalid Date';
};

const formatRoomLabel = (booking) => {
  const building = booking?.room?.buildingShort;
  const door = booking?.room?.doorLabel;

  if (building && door) {
    return `${building} - ${door}`;
  }

  return building || door || '-';
};

const formatBookingTypeLabel = (booking) => {
  const bookingTypeId = booking?.bookingTypeId;
  const bookingType = bookingTypeId
    ? masterData.value?.bookingTypes?.list?.[bookingTypeId]
    : null;

  if (bookingType?.title) {
    return bookingType.title;
  }

  if (bookingTypeId) {
    return `Typ ${bookingTypeId}`;
  }

  return 'Unbekannt';
};

const openBookingDetails = (booking) => {
  if (!booking?.id) return;
  bookingActions.viewBooking(booking);
};

// Chart option for bookings per day
const bookingsPerDayChartOption = computed(() => {
  if (!bookings.value || bookings.value.length === 0) {
    return {};
  }

  // Group bookings by date
  const bookingsByDate = {};
  bookings.value.forEach(booking => {
    const date = format(new Date(booking.startTime), 'yyyy-MM-dd', { in: berlinTz });
    if (!bookingsByDate[date]) {
      bookingsByDate[date] = 0;
    }
    bookingsByDate[date]++;
  });

  // Sort by date
  const sortedDates = Object.keys(bookingsByDate).sort();
  const dates = sortedDates.map(date => {
    return format(parseISO(date), 'dd.MM.yyyy');
  });
  const counts = sortedDates.map(date => bookingsByDate[date]);
  const minCount = Math.min(...counts);
  const maxCount = Math.max(...counts);
  const isFlatRange = minCount === maxCount;
  const yAxisMin = isFlatRange ? Math.max(0, minCount - 1) : Math.max(0, Math.floor(minCount * 0.9));
  const yAxisMax = isFlatRange ? maxCount + 1 : Math.ceil(maxCount * 1.1);

  return {
    tooltip: {
      trigger: 'axis'
    },
    grid: {
      left: '3%',
      right: '4%',
      top: 16,
      bottom: 56,
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: dates,
      axisLabel: {
        margin: 14,
        hideOverlap: true,
      },
    },
    yAxis: {
      type: 'value',
      min: yAxisMin,
      max: yAxisMax,
      minInterval: 1,
    },
    series: [
      {
        name: 'Buchungen',
        type: 'bar',
        data: counts,
        itemStyle: {
          color: '#409eff'
        }
      }
    ]
  };
});


return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" Date Range Controls "),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("label", {
              for: "from-date",
              class: "form-label-sm"
            }, "Von", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              id: "from-date",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((fromDateInput).value = $event)),
              type: "date",
              class: _normalizeClass(["form-control form-control-sm", { 'is-invalid': dateError.value }])
            }, null, 2 /* CLASS */), [
              [_vModelText, fromDateInput.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[3] || (_cache[3] = _createElementVNode("label", {
              for: "until-date",
              class: "form-label-sm"
            }, "Bis", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              id: "until-date",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((untilDateInput).value = $event)),
              type: "date",
              class: _normalizeClass(["form-control form-control-sm", { 'is-invalid': dateError.value }])
            }, null, 2 /* CLASS */), [
              [_vModelText, untilDateInput.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "btn btn-primary btn-sm w-100",
              disabled: dateError.value || isLoadingData.value,
              onClick: refreshData
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("i", { class: "fas fa-sync-alt me-1" }, null, -1 /* CACHED */),
              _createTextVNode(" Aktualisieren ", -1 /* CACHED */)
            ]))], 8 /* PROPS */, _hoisted_8)
          ])
        ]),
        (dateError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(dateError.value), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      _createCommentVNode(" Loading States "),
      (isLoadingData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"card mb-3\" data-v-11cbbf05><div class=\"card-body\" data-v-11cbbf05><div class=\"row g-3\" data-v-11cbbf05><div class=\"col-md-6\" data-v-11cbbf05><div class=\"skeleton skeleton-label\" data-v-11cbbf05></div><div class=\"skeleton skeleton-input\" data-v-11cbbf05></div></div><div class=\"col-md-6\" data-v-11cbbf05><div class=\"skeleton skeleton-label\" data-v-11cbbf05></div><div class=\"skeleton skeleton-input\" data-v-11cbbf05></div></div></div></div></div>", 1)),
            _createElementVNode("div", _hoisted_11, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "card-header" }, [
                _createElementVNode("div", { class: "skeleton skeleton-title" })
              ], -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
                    return _createElementVNode("div", {
                      key: n,
                      class: "col-md-4"
                    }, [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("div", { class: "skeleton skeleton-block" }, null, -1 /* CACHED */)
                    ]))])
                  }), 64 /* STABLE_FRAGMENT */))
                ])
              ])
            ]),
            _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"card\" data-v-11cbbf05><div class=\"card-header\" data-v-11cbbf05><div class=\"skeleton skeleton-title\" data-v-11cbbf05></div></div><div class=\"card-body\" data-v-11cbbf05><div class=\"skeleton skeleton-line\" data-v-11cbbf05></div><div class=\"skeleton skeleton-line w-75\" data-v-11cbbf05></div><div class=\"skeleton skeleton-line w-50\" data-v-11cbbf05></div></div></div><div class=\"card mt-3\" data-v-11cbbf05><div class=\"card-header\" data-v-11cbbf05><div class=\"skeleton skeleton-title\" data-v-11cbbf05></div></div><div class=\"card-body\" data-v-11cbbf05><div class=\"skeleton skeleton-chart\" data-v-11cbbf05></div></div></div>", 2))
          ]))
        : (_unref(bookingsError))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createCommentVNode(" Error States "),
              _createElementVNode("div", _hoisted_14, [
                _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1 /* CACHED */)),
                _cache[10] || (_cache[10] = _createTextVNode(" Fehler beim Laden der Daten: ", -1 /* CACHED */)),
                _createElementVNode("ul", _hoisted_15, [
                  _createElementVNode("li", null, _toDisplayString(_unref(bookingsError).message), 1 /* TEXT */)
                ])
              ])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createCommentVNode(" Data Content "),
              _createElementVNode("div", _hoisted_16, [
                _createCommentVNode(" Bookings Analytics "),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _cache[11] || (_cache[11] = _createElementVNode("h5", { class: "card-title mb-0" }, " Buchungsstatistiken ", -1 /* CACHED */)),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(bookings)?.length || 0) + " Buchungen ", 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    (_unref(bookings))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createCommentVNode(" Total Bookings "),
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(bookings).length), 1 /* TEXT */),
                            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "stat-label" }, " Gesamte Buchungen ", -1 /* CACHED */))
                          ]),
                          _createCommentVNode(" Future vs Past Split "),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, _toDisplayString(futureBookingsCount.value) + " / " + _toDisplayString(pastBookingsCount.value), 1 /* TEXT */),
                            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "stat-label" }, " Zukünftig / Vergangen ", -1 /* CACHED */))
                          ]),
                          _createCommentVNode(" Utilization Proxy "),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, _toDisplayString(utilizationPercentage.value) + "% ", 1 /* TEXT */),
                            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "stat-label" }, [
                              _createTextVNode(" Auslastung (Proxy) "),
                              _createElementVNode("i", {
                                class: "fas fa-info-circle ms-1",
                                title: "Prozentualer Anteil der Tage mit mindestens einer Buchung im Zeitraum",
                                "data-bs-toggle": "tooltip"
                              })
                            ], -1 /* CACHED */))
                          ]),
                          _createVNode(UserBookingMetrics, { bookings: _unref(bookings) }, null, 8 /* PROPS */, ["bookings"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_28, " Keine Buchungsdaten verfügbar "))
                  ])
                ]),
                _createCommentVNode(" Bookings per Day Chart "),
                (_unref(bookings) && _unref(bookings).length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "card-header d-flex justify-content-between align-items-center" }, [
                        _createElementVNode("h5", { class: "card-title mb-0" }, " Buchungen pro Tag ")
                      ], -1 /* CACHED */)),
                      _createElementVNode("div", _hoisted_30, [
                        (isLoadingBookingsPerDay.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [...(_cache[15] || (_cache[15] = [
                              _createElementVNode("div", {
                                class: "spinner-border text-primary",
                                role: "status"
                              }, [
                                _createElementVNode("span", { class: "visually-hidden" }, "Laden...")
                              ], -1 /* CACHED */),
                              _createElementVNode("p", { class: "mt-2" }, " Diagramm wird geladen... ", -1 /* CACHED */)
                            ]))]))
                          : (errorBookingsPerDay.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1 /* CACHED */)),
                                _createTextVNode(" Fehler beim Laden des Diagramms: " + _toDisplayString(errorBookingsPerDay.value.message), 1 /* TEXT */)
                              ]))
                            : (_openBlock(), _createBlock(_unref(VChart), {
                                key: 2,
                                class: "chart",
                                option: bookingsPerDayChartOption.value,
                                autoresize: ""
                              }, null, 8 /* PROPS */, ["option"]))
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Bookings List "),
                _createElementVNode("div", _hoisted_33, [
                  _cache[18] || (_cache[18] = _createElementVNode("div", { class: "card-header d-flex justify-content-between align-items-center" }, [
                    _createElementVNode("h5", { class: "card-title mb-0" }, " Raumbuchungen ")
                  ], -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_34, [
                    (_unref(bookings) && _unref(bookings).length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bookings), (booking) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: booking.id,
                              class: "booking-item border-bottom p-3"
                            }, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "booking-open-btn",
                                onClick: $event => (openBookingDetails(booking))
                              }, [
                                _createElementVNode("div", _hoisted_37, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_38, _toDisplayString(booking.title), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_39, _toDisplayString(formatDate(booking.startTime)) + ", " + _toDisplayString(formatTime(booking.startTime)) + " - " + _toDisplayString(formatTime(booking.endTime)), 1 /* TEXT */)
                                  ]),
                                  _createElementVNode("div", _hoisted_40, [
                                    _createElementVNode("div", _hoisted_41, _toDisplayString(formatBookingTypeLabel(booking)), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_42, _toDisplayString(formatRoomLabel(booking)), 1 /* TEXT */)
                                  ])
                                ])
                              ], 8 /* PROPS */, _hoisted_36)
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_43, " Keine Buchungen im ausgewählten Zeitraum "))
                  ])
                ])
              ])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
    ])
  ]))
}
}

}